import React, { memo, useEffect, useState } from "react";
import HeaderPage from "../../components/HeaderPage/Index";
import Loading from "../../components/loading/loading";
import {
  checkEditPage,
  clearData,
  getAllCountry,
  getAllStorage,
  getData,
  storeData,
} from "../../utils/GlobalHelper";
import { isMobile } from "react-device-detect";
import GlobalApi from "../../utils/GlobalApi";
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import ButtonRight from "../../components/BoxRightContent/ButtonRight";
import Configs from "../../constants/Configs";
import { Autocomplete, FormControl, Grid, TextField } from "@mui/material";
import HeaderRight from "../../components/BoxRightContent/HeaderRight";
import ScrollBarComponent from "../../components/BoxRightContent/ScrollBarComponent";
import { fomatterEN } from "../../utils/formatter";
import { isEmpty, isEqual, isNull } from "lodash";
import {
  CRSData,
  CRSBirthAddressKey,
  Idc,
  CRSDeclareLocationKey,
  CRSUnSaveRadioCheck,
  HeaderManpKey,
  CRSRadioChecked,
} from "../../utils/GlobalKey";
import DialogCustoms from "../../components/CustomDialog/DialogCustoms";

const CRSBirthAddress = (props) => {
  const translations = getData("Translations");
  const [isLoading, setIsLoading] = useState(false);
  const [countrysList, setCountryList] = useState([]);
  const [optionsCountry, setOptionsCountry] = useState([]);
  const [provinceList, setProvinceList] = useState([]);
  const [optionsProvince, setOptionsProvince] = useState([]);
  const [isShowProvince, setIsShowProvince] = useState(true);
  const [enableNextButton, setIsEnableNextButton] = useState(false);
  // const [birthCity, setBirthCity] = useState(null);
  const [lang, setLang] = useState(getData("lang"));
  const [openModal, setOpenModal] = useState(false);
  const crsBirthAddressStorage = getData(CRSBirthAddressKey);
  const unExpDate = getData("unExpDate");
  const defaultCRSBirthAddress = {
    country: null,
    province: null,
    city: null,
    provinceNameEn: null,
  };
  const [crsBirthAddressData, setCRSBirthAddressData] = useState(
    defaultCRSBirthAddress,
  );
  const thaiCountry = "212";

  //* check Jump Page
  const [jumpPage, setJumpPage] = useState(false);
  const checkJumpPage = async () => {
    const questions = getData("questionsAnswer");
    const pageAgree = getData("page_agree");
    const checkuserinfo = getData("checkuserinfo");
    const idc = getData(Idc);
    if (
      isEmpty(checkuserinfo) ||
      isEmpty(questions) ||
      isEmpty(pageAgree) ||
      pageAgree.termandcon !== 1 ||
      pageAgree.pdpa !== 1 ||
      isEmpty(idc)
    ) {
      return true;
    } else {
      return false;
    }
  };

  //* check path is edit
  const [editUrl, setEditUrl] = useState(false);
  const checkEditUrl = async () => {
    await checkEditPage().then(async (res) => {
      setEditUrl(res);
    });
  };

  const header = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  //Call API: เช็ค CRS จากที่อื่น
  const checkCRSWithAnother = async (idCard, headToken) => {
    const postData = {
      head_token: headToken,
      card_id: idCard,
    };

    try {
      await GlobalApi.post(
        `${Configs.baseAPIURL03}/form/crs/selbyhead`,
        postData,
        header,
      )
        .then(async (res) => {
          /*
                    Response เมื่อ มีการทำ CRS มาก่อน
                    {
                        "Data": [
                            {
                                "SAffc_Id": 21132,
                                "SAffc_SAfh_Id": 23794,
                                "SAffc_CityOfBirth": "Seoul",  //เมืองที่เกิด หรือ จังหวัด
                                "SAffc_CountryOfBirth": 82, //countryId ประเทศที่เกิด
                                "SAffc_USCitizen": 0, //เป็นบุคคลสหรัฐ 1=true, 0=false
                                "SAffc_Non_USCitizen": 1, //ไม่เป็นบุคคลสหรัฐ 1=true, 0=false
                                "SAffc_CreateBy": 99999,
                                "SAffc_CreateDate": {
                                    "date": "2024-01-10 17:45:59.587000",
                                    "timezone_type": 3,
                                    "timezone": "Asia/Bangkok"
                                },
                                "SAffc_UpdateBy": 99999,
                                "SAffc_UpdateDate": {
                                    "date": "2024-01-10 17:45:59.587000",
                                    "timezone_type": 3,
                                    "timezone": "Asia/Bangkok"
                                },
                                "CreateBy": null,
                                "UpdateBy": "",
                                "UpdateDate": "10/01/2024",
                                "UpdateTime": "17:45:59",
                                "f0_crs_tax_detail": [
                                    {
                                        "SAffcc_Id": 1,
                                        "SAffcc_SAfh_Id": 23794,
                                        "SAffcc_CNT_TaxResidence": 212, //ประเทศถิ่นที่อยู่ทางภาษี
                                        "SAffcc_TIN": "xxxxxxxxxxxxx", //เลขประจำตัวผู้เสียภาษี
                                        "SAffcc_Mrnt_Id": 0, //choice ที่เลือก กรณี ไม่มีหมายเลขประจำตัวผู้เสียภาษี
                                        "SAffcc_Explain": "", // เหตุผลอธิบายเพิ่มเติมเมื่อเลือก choice2 
                                        "SAffcc_Seqno": 1
                                    },
                                ]
                            }
                        ]
                    }
    
                    Response เมื่อไม่เคยทำ CRS
                    {
                        Data: [null]
                    }
                    */
          if (!isEmpty(res.data.Data) && !isNull(res.data.Data[0])) {
            const dataFromCrsWithAnoter = res.data.Data[0];

            let selectOptionsCountry = {
              label: "",
              value: "",
            };
            let selectOptionsProvince = {
              label: "",
              value: "",
            };

            //select country from selbyhead
            const findMatchCountry = countrysList.find(
              (country) =>
                country.Id ===
                dataFromCrsWithAnoter.SAffc_CountryOfBirth.toString(),
            );
            if (findMatchCountry) {
              selectOptionsCountry = {
                label: findMatchCountry.ThName,
                value: findMatchCountry.Id.toString(),
              };
              // setSelectCountry(selectOptionsCountry);
            }

            if (isEmpty(dataFromCrsWithAnoter.SAffc_CityOfBirth)) return;

            //select province from selbyhead
            const findMatchProvince = provinceList.find(
              (province) =>
                province.ThName === dataFromCrsWithAnoter.SAffc_CityOfBirth ||
                province.EnName.toLowerCase() ===
                  dataFromCrsWithAnoter.SAffc_CityOfBirth.toLowerCase(),
            );
            if (findMatchProvince) {
              selectOptionsProvince = {
                label: findMatchProvince.ThName,
                value: findMatchProvince.Id.toString(),
              };
              // setSelectProvince(selectOptionsProvince);
              // } else {
              // setBirthCity(dataFromCrsWithAnoter.SAffc_CityOfBirth);
            }
            setSelectCountryProvinceAndCity(
              selectOptionsCountry,
              selectOptionsProvince,
              dataFromCrsWithAnoter.SAffc_CityOfBirth,
            );

            const crsDataList = dataFromCrsWithAnoter.f0_crs_tax_detail.map(
              (item) => {
                const findMatchCountryFromCRSDeclareLocation =
                  countrysList.find(
                    (country) =>
                      country.Id === item.SAffcc_CNT_TaxResidence.toString(),
                  );
                return {
                  countryId:
                    findMatchCountryFromCRSDeclareLocation?.Id.toString() ?? "",
                  country: findMatchCountryFromCRSDeclareLocation?.ThName ?? "",
                  taxNumber: item.SAffcc_TIN,
                  checkNotax: item.SAffcc_Mrnt_Id !== 0,
                  notaxId: item.SAffcc_Mrnt_Id,
                  notaxId2Text: item.SAffcc_Explain,
                };
              },
            );

            await storeData(CRSData, crsDataList);
            await storeData(
              CRSRadioChecked,
              dataFromCrsWithAnoter.SAffc_Non_USCitizen === 1,
            );
          }
        })
        .catch((err) => {
          console.log("err: ", err);
          setIsLoading(false);
        });
    } catch (error) {
      console.log("err: ", error);
    }
  };

  //Call API: ประเทศทั้งหมด
  const getCountrys = async () => {
    setIsLoading(true);
    try {
      await getAllCountry()
        .then((res) => {
          setIsLoading(false);
          const cleanData = res.filter(
            (country) => country.ThName != "สหรัฐอเมริกา",
          );
          setCountryList(cleanData);

          const list = cleanData.map((country) => {
            return {
              value: country.Id,
              label: country.ThName,
            };
          });

          setOptionsCountry(list);

          if (!isEmpty(crsBirthAddressStorage)) return;

          //แสดง ไทย เมื่อโหลดเสร็จครั้งแรก
          const thaiObject = list.find((item) => item.label == "ไทย");
          if (thaiObject) {
            setSelectCountry(thaiObject);
            // handleSelectCountry(thaiObject);
          }
        })
        .catch((error) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
    return;
  };

  //Call API: จังหวัดทั้งหมด แต่ละประเทศ
  const getProvinces = async (countryId) => {
    if (provinceList.length != 0) {
      return;
    }

    setIsLoading(true);
    let getProvinceUrl = `${Configs.baseAPIURL03}/constant/province/${countryId}`;
    try {
      await GlobalApi.get(getProvinceUrl, header)
        .then(async (res) => {
          setIsLoading(false);

          const cleanData = res.data.Data;
          setProvinceList(cleanData);

          const list = cleanData.map((province) => {
            return {
              label: province.ThName,
              value: province.Id,
            };
          });

          setOptionsProvince(list);
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
    return;
  };

  //Call API: Save Comeback when Edit
  const saveComeBack = async () => {
    let isSuccess = false;
    const head_token = getData(HeaderManpKey)
      ? getData(HeaderManpKey).head_token
      : null;

    const last_stamp = JSON.stringify(await getAllStorage("SUMMARY"));
    try {
      await GlobalApi.post(
        `${Configs.baseAPIURL03}/form/comeback/manp`,
        {
          head_token: head_token,
          last_stamp: last_stamp,
          stamp_page: "SUMMARY",
        },
        header,
      )
        .then((res) => {
          if (res?.data?.Data?.[0]?.[0]?.IsSuccess === 1) {
            isSuccess = true;
          }
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    } catch (error) {
      console.log("error: ", error);
    }
    return isSuccess;
  };

  const setSelectCountry = (country) => {
    if (!country) {
      setCRSBirthAddressData(defaultCRSBirthAddress);
      setIsShowProvince(false);
      return;
    }

    // ไม่ใช่ไทย ให้เปลี่ยนเป็นกรอก เมืองที่เกิด
    if (!isEqual(country.label, "ไทย")) {
      setIsShowProvince(false);
      setCRSBirthAddressData({
        country: country,
        province: null,
        city: "",
      });
      return;
    }

    setIsShowProvince(true);
    setCRSBirthAddressData({
      country: country,
      province: null,
      city: null,
    });
  };

  const setSelectProvince = (province) => {
    if (!province) {
      setCRSBirthAddressData({
        ...crsBirthAddressData,
        province: null,
      });
      return;
    }

    setCRSBirthAddressData({
      ...crsBirthAddressData,
      province: province,
    });
  };

  const setBirthCity = (textBirthCity) => {
    setCRSBirthAddressData({
      ...crsBirthAddressData,
      city: textBirthCity,
    });
  };

  const setSelectCountryProvinceAndCity = (
    country,
    province,
    textBirthCity,
  ) => {
    if (!country) {
      setCRSBirthAddressData(defaultCRSBirthAddress);
      setIsShowProvince(false);
      return;
    }

    // ไม่ใช่ไทย ให้เปลี่ยนเป็นกรอก เมืองที่เกิด
    if (!isEqual(country.label, "ไทย")) {
      setIsShowProvince(false);
      setCRSBirthAddressData({
        country: country,
        province: null,
        city: textBirthCity,
      });
      return;
    }

    setIsShowProvince(true);
    setCRSBirthAddressData({
      country: country,
      province: province,
      city: null,
    });
  };

  const handleOptionsCountry = (value) => {
    if (isEmpty(value)) {
      const outputOptions = countrysList.map((country) => {
        return {
          value: country.Id,
          label: country.ThName,
        };
      });

      setOptionsCountry(outputOptions);
      return;
    }

    let findMatchOptions = countrysList.filter((country) =>
      country.ThName.startsWith(value),
    );
    const newOptionsCountry = findMatchOptions.map((item) => {
      return {
        label: item.ThName,
        value: item.Id,
      };
    });
    setOptionsCountry(newOptionsCountry);
  };

  const handleOptionsProvince = (value) => {
    if (isEmpty(value)) {
      const outputOptions = provinceList.map((province) => {
        return {
          value: province.Id,
          label: province.ThName,
        };
      });
      setOptionsProvince(outputOptions);
      return;
    }

    let findMatchOptions = provinceList.filter((province) =>
      province.ThName.startsWith(value),
    );
    const newOptionsProvince = findMatchOptions.map((item) => {
      return {
        label: item.ThName,
        value: item.Id,
      };
    });
    setOptionsProvince(newOptionsProvince);
  };

  const clickBack = () => {
    // ถ้า Edit ให้ Show Popup ยกเลิกแก้ไข
    if (enableNextButton && editUrl) {
      setOpenModal(true);
    } else if (editUrl) {
      props.history.push("/summary");
    } else {
      unExpDate
        ? props.history.push("/house_registration")
        : props.history.push("/IdcForm");
    }
  };

  const handleNextButton = async () => {
    let provinceNameEn = "";
    if (crsBirthAddressData && crsBirthAddressData.province) {
      provinceNameEn = crsBirthAddressData?.province?.label;
      const findProvinc = provinceList?.find(
        (pro) => pro.Id === crsBirthAddressData.province.value.toString(),
      );
      if (findProvinc) {
        provinceNameEn = findProvinc.EnName;
      }
    }

    let newBirthAddress = {
      country: crsBirthAddressData.country,
      province: crsBirthAddressData.province,
      city: crsBirthAddressData.city,
      provinceNameEn,
    };

    if (editUrl) {
      //Edit: Call Update Data -> Back to Summary
      let isSuccessAll = false;
      setIsLoading(true);
      const body = setTextSummary(provinceNameEn);
      const isSuccess = await postData(body);
      if (isSuccess) {
        storeData(CRSBirthAddressKey, newBirthAddress);
        const isSaveComeback = await saveComeBack();
        isSuccessAll = isSaveComeback;
      }
      setIsLoading(false);

      if (isSuccessAll) {
        props.history.goBack();
      }
    } else {
      //Insert: Redirect to DeclareLocation

      // check ว่าข้อมูลมีการ Update ให้ลบข้อมูล CRS หน้าถัดไป ทิ้ง
      let isUpdateData = !isEqual(crsBirthAddressStorage, crsBirthAddressData);

      if (isUpdateData) {
        await clearData(CRSDeclareLocationKey);
        await clearData(CRSUnSaveRadioCheck);
      }

      storeData(CRSBirthAddressKey, newBirthAddress);

      props.history.push("/declare_location");
    }
  };

  const setTextSummary = (provinceNameEn) => {
    const headToken = getData(HeaderManpKey)
      ? getData(HeaderManpKey).head_token
      : "";
    const crsDataList = getData(CRSData);

    const CRSDeclareLocationRequest = crsDataList.map((item) => {
      /*
            checkNotax: false = ไม่มีหมายเลขประจำตัวผู้เสียภาษี
            country: (string) = ชื่อประเทศ
            countryId: (string) = CountryId
            notaxId: (int) = choice ที่เลือก เมื่อ ไม่มีหมายเลขประจำตัวผู้เสียภาษี
            notaxId2Text: (string) = เหตุผลอธิบายเพิ่มเติม เมื่อเลือก choice 2
            taxNumber: (string) = หมายเลขประจำตัวผู้เสียภาษี
            */
      return {
        SAffcc_CNT_TaxResidence: item.countryId,
        SAffcc_TIN: item.taxNumber,
        SAffcc_Mrnt_Id: item.notaxId,
        SAffcc_Explain: item.notaxId2Text,
      };
    });

    return {
      head_token: headToken, //token from manp
      f0_city_of_birth: crsBirthAddressData.province
        ? provinceNameEn
        : crsBirthAddressData.city, //เมืองที่เกิด หรือ จังหวัด
      f0_country_of_birth: crsBirthAddressData.country.value, //countryId
      f0_us_citizen: "false", //เป็นบุคคลสหรัฐไหม
      f0_non_us_citizen: "true", //ไม่เป็น บุคคลสหรัฐ ไหม
      f0_crs_tax_detail: JSON.stringify(CRSDeclareLocationRequest),
    };
  };

  const postData = async (postData) => {
    let isSuccess = false;
    try {
      await GlobalApi.post(
        `${Configs.baseAPIURL03}/form/crs/manp`,
        postData,
        header,
      )
        .then((res) => {
          isSuccess = true;
        })
        .catch((err) => {});
    } catch (error) {}
    return isSuccess;
  };

  useEffect(async () => {
    // check jump page
    checkJumpPage().then((res) => {
      if (res) setJumpPage(res);
    });

    //check edit Page
    await checkEditUrl();

    // ครั้งแรก โหลด ประเทศ ทั้งหมด
    await getCountrys();

    // หากมี cache ให้ใช้ ข้อมูล cache
    if (!isEmpty(crsBirthAddressStorage)) {
      setCRSBirthAddressData(crsBirthAddressStorage);
      if (isEqual(crsBirthAddressStorage.country.label, "ไทย")) {
        setIsShowProvince(true);
      } else {
        setIsShowProvince(false);
      }
    }
  }, []);

  // โหลด จังหวัด ทั้งหมด (รองรับเฉพาะ ประเทศไทย)
  useEffect(async () => {
    if (
      !isEmpty(crsBirthAddressData.country) &&
      !isEmpty(crsBirthAddressData.country.value) &&
      isEmpty(provinceList)
    ) {
      // const thaiData = countrysList.find((country) => country.label == "ไทย");
      if (crsBirthAddressData.country.label == "ไทย") {
        const countryId = crsBirthAddressData.country.value; //CountryId
        await getProvinces(countryId);
      }
    }
  }, [crsBirthAddressData.country]);

  // เมื่อเข้าสู่ CRS ครั้งแรก ให้เช็ึค CRS จาก Id
  useEffect(async () => {
    if (
      !editUrl &&
      !isEmpty(countrysList) &&
      !isEmpty(provinceList) &&
      !crsBirthAddressStorage
    ) {
      const idCard = getData(Idc) ? getData(Idc).idCard : "";
      // const idCard = "1119900519385";
      const headToken = getData(HeaderManpKey)
        ? getData(HeaderManpKey).head_token
        : null;
      await checkCRSWithAnother(idCard, headToken);
    }
  }, [provinceList]);

  // เช็ค enable button
  useEffect(() => {
    if (
      (!isEmpty(crsBirthAddressData.country) &&
        !isEmpty(crsBirthAddressData.province)) ||
      (!isEmpty(crsBirthAddressData.country) &&
        !isEmpty(crsBirthAddressData.city))
    ) {
      setIsEnableNextButton(true);
    } else {
      setIsEnableNextButton(false);
    }

    if (editUrl) {
      if (isEqual(crsBirthAddressData, crsBirthAddressStorage)) {
        setIsEnableNextButton(false);
      } else {
        setIsEnableNextButton(true);
      }
    }
  }, [
    crsBirthAddressData.country,
    crsBirthAddressData.province,
    crsBirthAddressData.city,
  ]);

  const handleRedirectToSummary = (isBack) => {
    if (isBack) {
      props.history.goBack();
    }
  };

  const handleEnableButton = () => {
    let res = true;
    if (crsBirthAddressData && crsBirthAddressData.country) {
      if (
        crsBirthAddressData.country.value === thaiCountry &&
        crsBirthAddressData.province
      ) {
        res = false;
      } else if (
        crsBirthAddressData.country.value !== thaiCountry &&
        crsBirthAddressData.city
      ) {
        res = false;
      }
    }
    return res;
  };

  return (
    <>
      {jumpPage ? (
        <>
          <Grid className="app-splash-screen"></Grid>
        </>
      ) : (
        <>
          <HeaderPage
            title="เปิดบัญชีออนไลน์"
            onChangeLang={(e) => setLang(e)}
            clickBack={(e) => (e ? clickBack() : "")}
          />
          <Loading status={isLoading} />
          {openModal && editUrl && (
            <DialogCustoms
              open={openModal}
              isModel={setOpenModal}
              title={"ยกเลิกการแก้ไข"}
              massage={
                "การแก้ไขยังไม่ได้ถูกบันทึก ท่านต้องการ\nออกจากหน้านี้หรือไม่"
              }
              idBtnPrimary="continue"
              idBtnSecondary="retry"
              btnPrimary={"ออกจากหน้านี้"}
              btnSecondary={"อยู่หน้านี้ต่อ"}
              switchType={(e) => handleRedirectToSummary(e)}
            />
          )}
          <Grid className="background-bg">
            <Grid className="section-consent">
              <Grid className={isMobile ? "box-content-mb" : "box-content"}>
                <Grid container className="box-content-main" columns={16}>
                  {!isMobile && (
                    <Grid item xs={7} className="box-left">
                      <BoxLeftContent
                        translations={translations?.[lang]?.checkuserinfo}
                        clickBack={(e) => clickBack()}
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={isMobile ? 16 : 9}
                    className={isMobile ? "box-right-mb" : "box-right"}
                  >
                    <Grid className="content">
                      <Grid className="content-main">
                        <Grid
                          className="box-right-content pb-3"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                          }}
                        >
                          <HeaderRight title="สถานที่เกิด" />
                          {editUrl}
                          <ScrollBarComponent
                            content={
                              <Grid>
                                <Grid className="input-form">
                                  <FormControl variant="standard" fullWidth>
                                    <Autocomplete
                                      id="select-country"
                                      options={optionsCountry}
                                      getOptionLabel={(option) =>
                                        option.label ? option.label : ""
                                      }
                                      value={
                                        crsBirthAddressData.country
                                          ? {
                                              label:
                                                crsBirthAddressData.country
                                                  .label,
                                              value:
                                                crsBirthAddressData.country
                                                  .value,
                                            }
                                          : null
                                      }
                                      isOptionEqualToValue={(option, value) => {
                                        // console.log('options: ', JSON.stringify(option));
                                        // console.log('value: ', JSON.stringify(value));
                                        return option.label === value.label;
                                      }}
                                      onChange={(e, value) => {
                                        setSelectCountry(value ?? "");
                                      }}
                                      onInputChange={(e, value, reason) => {
                                        handleOptionsCountry(value);
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          id="input-country"
                                          variant="standard"
                                          label="ประเทศที่เกิด"
                                          placeholder="พิมพ์เพื่อค้นหาและเลือก"
                                          required
                                        />
                                      )}
                                    />
                                  </FormControl>
                                </Grid>
                                <Grid className="input-form">
                                  {isShowProvince ? (
                                    <FormControl variant="standard" fullWidth>
                                      <Autocomplete
                                        id="select-province"
                                        options={optionsProvince}
                                        getOptionLabel={(option) =>
                                          option.label ? option.label : ""
                                        }
                                        value={
                                          crsBirthAddressData.province
                                            ? {
                                                label:
                                                  crsBirthAddressData.province
                                                    .label,
                                                value:
                                                  crsBirthAddressData.province
                                                    .value,
                                              }
                                            : null
                                        }
                                        isOptionEqualToValue={(option, value) =>
                                          option.label === value.label
                                        }
                                        onChange={(e, value) => {
                                          setSelectProvince(value ?? "");
                                        }}
                                        onInputChange={(e, value, reason) => {
                                          handleOptionsProvince(value);
                                        }}
                                        disabled={!isShowProvince}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            id="input-province"
                                            variant="standard"
                                            label="จังหวัด"
                                            placeholder="ตัวอย่าง กรุงเทพมหานคร"
                                            required
                                          />
                                        )}
                                      />
                                    </FormControl>
                                  ) : (
                                    <FormControl
                                      variant="standard"
                                      fullWidth
                                      error
                                    >
                                      <TextField
                                        id="input-city"
                                        label="เมืองที่เกิด (ภาษาอังกฤษเท่านั้น)"
                                        variant="standard"
                                        value={crsBirthAddressData.city ?? ""}
                                        fullWidth
                                        placeholder="ตัวอย่าง Seoul"
                                        required
                                        onChange={(e) =>
                                          setBirthCity(
                                            fomatterEN(e.target.value),
                                          )
                                        }
                                        inputProps={{ maxLength: 200 }}
                                      />
                                    </FormControl>
                                  )}
                                </Grid>
                              </Grid>
                            }
                          />
                          <ButtonRight
                            id="nextPage"
                            text={editUrl ? "บันทึก" : "ถัดไป"}
                            onNextPage={handleNextButton}
                            isDisbled={handleEnableButton()}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default memo(CRSBirthAddress);
